import { rest } from 'msw';
import { isAdminPath } from '@functional';
import * as mocks from '~/mock';
import { ORIGINS } from '~/constants/api';

/**
 * MSWエンドポイント
 * レスポンスはパラメータを元に分岐したり、変更しても良いです。
 */
export const handlers = [
  // handover
  rest.post(`${ORIGINS.GMOASK_BFF}/handover/gmoask`, async (req, res, ctx) => {
    const { apiUri, httpMethod } = await req.json();

    switch (apiUri) {
      case '/surveys':
        return res(ctx.json(httpMethod === 'POST' ? mocks.survey : mocks.surveys));

      case '/surveys/select_by_admin':
        return res(ctx.json(mocks.adminSurveys));

      case '/surveys/quotas':
        return res(ctx.json(mocks.quotas));

      case '/available_delivery_start_date':
        return res(ctx.json(mocks.availableDeliveryStartDate));

      case process.env.REACT_APP_CALCSURVEY_URI:
        return res(ctx.json(mocks.surveyPrices));

      case '/invoice_recipients':
        return res(ctx.json(mocks.invoiceRecipients));

      case '/surveys/estimate_payments':
        return res(ctx.json(mocks.estimatePayments));

      case '/surveys/apply':
        return res(ctx.json(mocks.apply));

      case '/surveys/approve':
        return res(ctx.json(mocks.approve));

      case '/surveys/reject':
        return res(ctx.json(mocks.surveysReject));

      case '/users':
        return res(ctx.json(mocks.users));

      case '/users/allowed_payment_type':
        return res(ctx.json(mocks.allowedPaymentType));

      case '/users/export':
        return res(ctx.json(mocks.usersExport));

      case '/administrator_roles':
        return res(
          ctx.json(
            httpMethod === 'POST' ? mocks.administratorRolesUpdate : mocks.administratorRoles
          )
        );

      case '/administrators':
        return res(ctx.json(mocks.administratorAndRoles));

      case '/roles':
        return res(ctx.json(mocks.roles));

      case '/users/screen_visibility_settings':
        return res(
          ctx.json(
            httpMethod === 'POST'
              ? mocks.userScreenVisibilitySetting
              : mocks.userScreenVisibilitySettings
          )
        );

      case '/surveys/get_mini_enquete':
        return res(ctx.json(mocks.pastSurvey));

      case '/receipt_request':
        return res(ctx.json(mocks.receiptRequest));

      default:
        return res(
          ctx.status(-404),
          ctx.json({ status: -404, message: 'ResourceNotExistsException' })
        );
    }
  }),

  rest.get(`${ORIGINS.GMOASK_BFF}/csrf-token`, (req, res, ctx) => {
    return res(ctx.json(mocks.csrfToken));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/users`, (req, res, ctx) => {
    return res(ctx.json(mocks.users));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/administrators`, (req, res, ctx) => {
    return res(ctx.json(mocks.administrators));
  }),

  rest.get(`${ORIGINS.GMOASK_BFF}/area`, (req, res, ctx) => {
    return res(ctx.json(mocks.area));
  }),

  rest.get(`${ORIGINS.GMOASK_BFF}/available_delivery_start_date`, (req, res, ctx) => {
    return res(ctx.json(mocks.availableDeliveryStartDate));
  }),

  rest.get(`${ORIGINS.GMOASK_BFF}/delivery_setting`, (req, res, ctx) => {
    // 簡易的にAdminは審査フロー入りを返す
    if (isAdminPath()) {
      return res(ctx.json(mocks.deliverySettingJudgement2));
    }

    if (req.url.search === '?surveyId=201') {
      return res(ctx.json(mocks.deliverySettingOriginalFormCompleted));
    }

    if (req.url.search === '?surveyId=202') {
      return res(ctx.json(mocks.deliverySettingOriginalFormRegistering));
    }

    if (req.url.search === '?surveyId=203') {
      return res(ctx.json(mocks.deliverySettingOriginalFormAnswering));
    }

    return res(ctx.json(mocks.deliverySetting2));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/estimated_delivery_target/counts`, (req, res, ctx) => {
    return res(ctx.json(mocks.estimatedDeliveryTargetCountsQuotaEach));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/users/reset_password`, (req, res, ctx) => {
    return res(ctx.json(mocks.resetPassword));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/administrators/reset_password`, (req, res, ctx) => {
    return res(ctx.json(mocks.resetPassword));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/users/verify_reset_password`, (req, res, ctx) => {
    return res(ctx.json(mocks.verifyResetPassword));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/administrators/verify_reset_password`, (req, res, ctx) => {
    return res(ctx.json(mocks.verifyResetPassword));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/surveys/quotas`, (req, res, ctx) => {
    return res(ctx.json(mocks.verifyResetPassword));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/available_delivery_start_date`, (req, res, ctx) => {
    return res(ctx.json(mocks.availableDeliveryStartDate));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/users/login`, (req, res, ctx) => {
    return res(ctx.json(mocks.login));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/administrators/login`, (req, res, ctx) => {
    return res(ctx.json(mocks.login));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/survey_payments/card/complete`, (req, res, ctx) => {
    return res(ctx.json(mocks.surveyPaymentsCardComplete));
  }),

  rest.get(`${ORIGINS.GMOASK_BFF}/addresses`, (req, res, ctx) => {
    return res(ctx.json(mocks.addresses));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/users/logout`, (req, res, ctx) => {
    return res(ctx.json(mocks.logout));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/administrators/logout`, (req, res, ctx) => {
    return res(ctx.json(mocks.logout));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/survey_payments/card`, (req, res, ctx) => {
    return res(ctx.json(mocks.surveyPaymentsCard));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/users/authenticated_user`, (req, res, ctx) => {
    return res(ctx.json(mocks.authenticatedUser));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/users/anti_social_check`, (req, res, ctx) => {
    return res(ctx.json(mocks.antiSocialCheck));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/users/anti_social_check_approval`, (req, res, ctx) => {
    return res(ctx.json(mocks.antiSocialCheckApproval));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/users/credit_check`, (req, res, ctx) => {
    return res(ctx.json(mocks.creditCheck));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/users/withdraw`, (req, res, ctx) => {
    return res(ctx.json(mocks.withdraw));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/original_forms`, (req, res, ctx) => {
    return res(ctx.json(mocks.originalForm));
  }),

  rest.put(`${ORIGINS.GMOASK_BFF}/original_forms/questions_content`, (req, res, ctx) => {
    return res(ctx.json(mocks.updateQuestionsContent));
  }),

  rest.get(`${ORIGINS.GMOASK_BFF}/original_forms/questions_content`, (req, res, ctx) => {
    if (req.url.search !== '?surveyId=108') {
      return res(ctx.json(mocks.getQuestionsContents));
    }

    return res(ctx.json(mocks.getQuestionsContentsNew));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/original_forms/finalize`, (req, res, ctx) => {
    return res(ctx.json(mocks.finalizeSurvey));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/images/upload`, (req, res, ctx) => {
    return res(ctx.json(mocks.imageUpload));
  }),

  rest.get(`${ORIGINS.GMOASK_BFF}/original_forms/summary/json`, (req, res, ctx) => {
    if (req.url.search === '?surveyId=203') {
      return res(ctx.json(mocks.summaryJsonNotExecuted));
    }

    return res(ctx.json(mocks.summaryJson));
  }),

  rest.get(`${ORIGINS.GMOASK_BFF}/original_forms/summary/excel`, (req, res, ctx) => {
    return res(ctx.json(mocks.summaryExcel));
  }),

  rest.get(`${ORIGINS.GMOASK_BFF}/original_forms/preview/draft`, (req, res, ctx) => {
    return res(ctx.json(mocks.previewSurvey));
  }),

  rest.get(`${ORIGINS.GMOASK_BFF}/original_forms/preview/finalized`, (req, res, ctx) => {
    return res(ctx.json(mocks.previewSurvey));
  }),

  rest.get(`${ORIGINS.GMOASK_BFF}/original_forms/draft_ng_words`, (req, res, ctx) => {
    return res(ctx.json(mocks.draftNgWords));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/original_forms/copy`, (req, res, ctx) => {
    return res(ctx.json(mocks.miniEnqueteCopy));
  }),

  rest.post(`${ORIGINS.GMOASK_BFF}/inquiry`, (req, res, ctx) => {
    return res(ctx.json(mocks.userInquiry));
  }),
];
